import { useMutation } from "@tanstack/react-query";
import SelectContact from "components/AddressBook/SelectContact";
import Modal from "components/modal";
import EditParticipantAsContact from "eSign/components/modals/EditParticipantAsContact";
import { type SetParticipantFromContactParams } from "eSign/components/Participant/hooks";
import React, { useState } from "react";

interface Props {
  advancingSessionId: number
  showId: number
  onInvited: () => void
  onClose: () => void
}

export const InviteParticipantModal = (props: Props) => {
  const [contact, setContact] = useState<{
    contactId: number
    contactName: string
    culture: server.dto.Culture
    email: string
  }>();

  const inviteMutation = useMutation({
    mutationFn: async ({ email, contactId, culture, invitationBody, invitationSubject }: SetParticipantFromContactParams) => {
      const res = await window.CoreApi.AdvancingSession.AddAdvancingParticipant({
        itemId: props.advancingSessionId,
        participant: {
          contactId,
          contactCulture: culture,
          email,
          invitationSubject,
          invitationBody
        }
      });

      if (res.data.hasErrors) {
        return res.data.errors[0].message;
      }

      props.onInvited();
    }
  });

  const onContactSelected = (contact: server.dto.ContactAddressBookEntry, culture: server.dto.Culture, email: string) => {
    setContact({
      contactId: contact.contactId,
      contactName: contact.name.fullName,
      culture,
      email
    });
  };

  if (!contact) {
    return <Modal
      isOpen
      handleClose={props.onClose}
      title="Invite participant"
      width="small"
      height={750}
    >
      <SelectContact
        hasNoCompany
        suggestedApiInstruction={{ itemId: props.showId, mainArea: "show" }}
        onContactSelected={onContactSelected}
      />
    </Modal>;
  }

  return <Modal
    isOpen
    handleClose={props.onClose}
    title="Invite participant"
    width="small"
  >
    <EditParticipantAsContact
      contactName={contact.contactName}
      contactId={contact.contactId}
      initialEmail={contact.email}
      initialCompany={null}
      initialCulture={contact.culture}
      initialInvitationBody=""
      initialInvitationSubject=""
      saveMutation={inviteMutation}
      isViewer
      onPreviousStepClicked={() => setContact(undefined)}
      messageTemplateType="invitationForAdvancing"
    />
  </Modal>;
};
